import React, { useEffect, useState } from "react";
import { axiosapi } from "../api/axiosapi";
import jwt_decode from "jwt-decode";


const LoginForm = (props) => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [persist, setPersist] = useState(false);
    useEffect(() => {
        setError(
            ""
        )
    }, [email, password])

    useEffect(() => {
        localStorage.setItem('persist', persist)
    }, [persist])

    const handleSubmit = async (event) => {

        event.preventDefault();
        // handle form submission here
        if (email === "" || password === "") {
            setError(
                "Email or password is required"
            )
        }
        else {
            const userData = {

                email: email,
                password: password

            }
            const response = await axiosapi.post("/auth/login", userData,
                {
                    headers:
                        { 'Content-type': 'application/json' },
                    withCredentials: true
                },

            )
            if (response.data.success) {

                var decoded = jwt_decode(response.data.accessToken);
                const userInfo = {
                    email: decoded.email,
                    name: decoded.name,
                    id: decoded.id,
                    accessToken: response.data.accessToken,
                    userRoles: decoded.userRoles
                }
                props.addUserDetailsToState(userInfo);
            }
            else {
                setError(response.data.message)
            }
        }

    };
    const togglePersist = () => {
        setPersist(!persist)
    }


    return (
        <>


            <p className="pt-5 text-center font-bold text-3xl ">Welcome back!</p>

            <form className="max-w-lg mx-auto mt-8 px-5 " onSubmit={handleSubmit}>
                {error ? <p className="text-red-400 mb-3">{error}</p> : <></>}

                <div className="mt-4">
                    <label htmlFor="email" className="block font-medium text-gray-700">
                        Email
                    </label>
                    <input
                        id="email"
                        type="email"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="mt-4">
                    <label htmlFor="password" className="block font-medium text-gray-700">
                        Password
                    </label>
                    <input
                        id="password"
                        type="password"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <div className="mt-4 flex gap-2 ">
                    <input
                        type="checkbox"
                        id="rememberMeCheckbox"
                        checked={persist}
                        onChange={togglePersist}
                    />
                    <p>Remember Me</p>
                </div>
                <div className="mt-4 flex justify-center">
                    <button
                        type="submit"
                        className="py-2 px-4 w-[100%] bg-[#3399FF] text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                        Log in
                    </button>
                </div>
                <p className="text-center mt-4 font-bold">New to Busbud ? <span className="text-[#3399FF] font-bold cursor-pointer" onClick={() => props.onClick(false)}>Sign up</span></p>
            </form>
        </>
    );
};

export default LoginForm;
